import React from 'react';

const LoginLayout: React.FC = ({ children }) => {
	return <>{children}</>;
};

export default LoginLayout;
